import fetch from 'node-fetch';
import { getAppEnvironmentSettings } from '@pb/apps/offers/services/environment';

export async function isPhoneNumberValid(
    phoneNumber: string
): Promise<boolean> {
    const { baseUrl } = getAppEnvironmentSettings();
    const result = await fetch(
        `${baseUrl}/api/PhoneNumberValidation/Get?phoneNumber=${phoneNumber}`,
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Cache': 'no-cache',
                'X-Requested-With': 'XMLHttpRequest',
            },
            // @ts-ignore
            credentials: 'include',
        }
    );

    if (result.status >= 400) {
        throw result;
    }

    return await result.json();
}
